import { calculateMockCalculators } from "../mocks/calculators.mocks";
import { CalculatorsRequest, CalculatorsResponse } from "../models/calculators.models";
import { api, apiUrl } from "../../../shared/services/service";
import { validateCalculatorsRequest } from "../utils/calculators.validation";
import axios from "axios";

const CALCULATORS_ENDPOINT = `${apiUrl}/pbi/calculators/calculate`;

export const calculateCalculators = async (
  request: CalculatorsRequest,
  useMockData: boolean,
): Promise<CalculatorsResponse> => {
  const validationErrors = validateCalculatorsRequest(request);

  if (validationErrors.length > 0) {
    throw new Error(`Invalid calculators input. ${validationErrors.join(" ")}`);
  }

  if (useMockData) {
    return calculateMockCalculators(request);
  }

  const response = await api.post<CalculatorsResponse>(CALCULATORS_ENDPOINT, request);

  return response.data;
};

export const getCalculatorsErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseBody = error.response?.data as { error?: unknown; message?: unknown } | undefined;
    const responseMessage = responseBody?.error ?? responseBody?.message;

    if (typeof responseMessage === "string" && responseMessage.trim()) {
      return responseMessage;
    }

    return error.message;
  }

  return error instanceof Error ? error.message : "The calculator request failed.";
};
